/*
 * @Description 组件 IndexRight 布局
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- index-page-right start -->
	<div :class="{'index-page-right': true, 'no-notices': !noticeShowFlag && false}">
		
		<!-- 组件 今日报警 -->
		<IndAlarmsToday />
		
		<!-- 组件 各类报警 -->
		<!--<IndAlarm />-->
		
		<!-- 组件 现场人员 -->
		<IndRBSiteUser />
		
		<!--<transition name="el-zoom-in-bottom">-->
			<!-- 组件 消息通知 -->
			<!--<IndNotice v-show="noticeShowFlag" @changeNoticeState="changeNoticeState" />-->
		<!--</transition>-->
		
	</div>
	<!-- index-page-right end -->
</template>

/* JS */
<script>
	// 组件 今日报警
	import IndAlarmsToday from '@/components_index/IndexItems/IndAlarmsToday';
	// 组件 各类报警
	import IndAlarm from '@/components_index/IndexItems/IndAlarm';
	// 组件 消息通知
	// import IndNotice from '@/components_index/IndexItems/IndNotice';
	// 组件 现场人员
	import IndRBSiteUser from '@/components_index/IndexItems/IndRBSiteUser';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndexRight",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	// 组件 今日报警
        	IndAlarmsToday,
        	// 组件 各类报警
        	// IndAlarm,
        	// 组件 消息通知
        	// IndNotice,
        	// 组件 现场人员
          	IndRBSiteUser,
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// flag 展示消息推送模块
				noticeShowFlag: false,
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			/**
			 * @Des notice 状态改变
			 * @Auth
			 * @Date 
			 */
			changeNoticeState(flag) {
				// flag 展示消息推送模块
				this.noticeShowFlag = flag && true;
			},
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>




// WEBPACK FOOTER //
// src/components_index/IndexPage/IndexRight.vue